<template>
  <h2>商业计划书BP撰写服务</h2>
  <h3 class="form-title">写好商业计划书,融资就成功了一半!</h3>
  <div class="paragraph">
    商业计划书是投资人投资决策最重要的敲门砖，需要讲述一个符合投资人投资逻辑的故事。要求逻辑清晰，富有吸引力，整体包括投资亮点、市场分析、产品服务、商业模式、盈利模式、融资财务等板块，每份定价48000元。如企业复杂难度较大会酌情增加收费，请联系客服了解详情。
  </div>
  <div style="color: red; font-weight: bold">
    熟知投资人投资逻辑 优质成功案例 熟悉资本市场
  </div>
  <div style="color: red; font-weight: bold">
    专业策划团队 高效沟通对接 对接专业机构
  </div>
  <div class="img-row">
    <img :src="require('/src/assets/images/planBG.png')" />
  </div>
  <div class="img-row">
    <img :src="require('/src/assets/images/Plan1.png')" />
  </div>
  <div class="img-row">
    <img :src="require('/src/assets/images/Plan2.png')" />
  </div>
  <div class="paragraph">商业计划书流程：</div>
  <div class="img-row">
    <img :src="require('/src/assets/images/Plan3.jpg')" />
  </div>
  <div>商业计划书标准范例：</div>
  <ul>
    <li>1.公司简介 5</li>
    <li style="padding-left: 10px">1.1公司基本情况 5</li>
    <li style="padding-left: 10px">1.2股东情况 6</li>
    <li style="padding-left: 10px">1.3治理结构 7</li>
    <li style="padding-left: 20px">1.3.1组织结构图 7</li>
    <li style="padding-left: 20px">1.3.2组织机构及职责 7</li>
    <li style="padding-left: 20px">1.3.3董事、监事和高级管理人员 7</li>
    <li style="padding-left: 20px">1.3.4现任董监高简历 8</li>
    <li>2.产品/服务描述 9</li>
    <li style="padding-left: 10px">2.1. 管理及业务咨询 9</li>
    <li style="padding-left: 10px">2.2. 行业大数据及应用平台 9</li>
    <li style="padding-left: 10px">2.3中转产品与服务介绍 11</li>
    <li>3.激励机制 11</li>
    <li style="padding-left: 10px">3.1健全绩效考核制度 12</li>
    <li style="padding-left: 10px">3.2加强企业文化建设 12</li>
    <li style="padding-left: 10px">3.3员工持股计划 12</li>
    <li>4.行业及市场 12</li>
    <li style="padding-left: 10px">4.1公司行业归属 12</li>
    <li style="padding-left: 10px">4.2产业政策 13</li>
    <li style="padding-left: 20px">4.2.1战略性新兴产业 13</li>
    <li style="padding-left: 20px">4.2.2国家层面行业产业政策梳理 14</li>
    <li style="padding-left: 10px">4.3 存在问题 24</li>
    <li>5. 公司经营分析 24</li>
    <li style="padding-left: 10px">5.1面临的市场环境 24</li>
    <li style="padding-left: 20px">
      5.1.1密集型行业微小优化有利于企业效益提升 25
    </li>
    <li style="padding-left: 20px">5.1.2 产品同质化和低边际成本 25</li>
    <li style="padding-left: 20px">5.1.3 完全竞争市场 26</li>
    <li style="padding-left: 20px">5.1.4 市场壁垒 26</li>
    <li style="padding-left: 10px">5.2 目标客户分析 26</li>
    <li style="padding-left: 10px">5.3 盈利模式 27</li>
    <li style="padding-left: 10px">5.4 团队业绩 27</li>
    <li style="padding-left: 10px">5.5 目标市场规模 28</li>
    <li style="padding-left: 10px">5.6公司经营 30</li>
    <li style="padding-left: 20px">5.6.1 管理咨询及业务咨询 30</li>
    <li style="padding-left: 20px">5.6.2 行业大数据及应用平台 30</li>
    <li style="padding-left: 20px">5.6.3 中转平台及中转服务 30</li>
    <li>6.竞争分析 31</li>
    <li style="padding-left: 10px">6.1 行业管理及业务咨询竞争格局 31</li>
    <li style="padding-left: 10px">6.2主要竞争企业 31</li>
    <li style="padding-left: 20px">6.2.1 Scbr公司 31</li>
    <li style="padding-left: 20px">6.2.2麦肯锡公司 32</li>
    <li>7.公司优势 33</li>
    <li style="padding-left: 10px">7.1 团队优势 33</li>
    <li style="padding-left: 10px">7.2产品优势 33</li>
    <li style="padding-left: 10px">7.3服务优势 33</li>
    <li style="padding-left: 10px">7.4客户资源优势 34</li>
    <li style="padding-left: 10px">7.5计划申请的软件著作权及专利 34</li>
    <li>8.公司风险 35</li>
    <li style="padding-left: 10px">8.1行业大数据及应用平台竞争风险 35</li>
    <li style="padding-left: 10px">8.2 中转平台及中转服务竞争风险 35</li>
    <li>9.融资计划 35</li>
    <li style="padding-left: 10px">9.1 资源需求 35</li>
    <li style="padding-left: 10px">9.2 盈利预测 36</li>
    <li style="padding-left: 20px">9.2.1 五年盈利预测 36</li>
    <li style="padding-left: 20px">9.2.2 2020-2023收益预估 37</li>
    <li style="padding-left: 10px">9.3 退出方式 39</li>
  </ul>
  <div class="img-row">
    <img :src="require('/src/assets/images/Plan4.jpg')" />
  </div>
  <div class="paragraph">只需30分钟，帮你搞定投资人！</div>
  <div>
    联系方式:
    <ul>
      <li>电话：021-68828928, 15216609136</li>
      <li>E-mail：duanshihua@foxmail.com, 3450306099@qq.com</li>
      <li>QQ：3450306099, 2985437939</li>
      <li>微信：ksqj08, duanshihuaweixin</li>
    </ul>
  </div>

</template>

<script>
export default {
  name: "PlanTable",
  data() {
    return {};
  },
  components: {},
};
</script>
<style lang="less">
.form-title {
  padding-left: 15px;
}
.img-row {
  text-align: center;
  margin: 10px auto 10px auto;
  img {
    max-width: 95%;
  }
}
</style>
